import React from "react";
import { Typography, Box } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import pretty from "Shared/pretty";
import useStyles from "./styles";
import { GetPartnerRolesQuery, GetPartnerRolesQueryVariables } from "generated/graphql";

const TooltipContent = () => {
  const classes = useStyles();
  const { data } = useQuery<
    GetPartnerRolesQuery,
    GetPartnerRolesQueryVariables
  >(queries.GET_PARTNER_ROLES);

  if (!data?.partnerRoles?.totalCount) {
    return null;
  }

  return (
    <>
      {data.partnerRoles.items.map(partnerRole => (
        <Box key={partnerRole.oid} className={classes.partnerRole}>
          <Typography variant="h6" className={classes.text}>
            {pretty.startCase(partnerRole.oid)}
          </Typography>
          <Typography variant="body1" className={classes.text}>
            {partnerRole.description}
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default TooltipContent;
